import styles from './BundleSummaryMoreContainer.scss';

import cx from 'classnames';
import React, { FC, HTMLAttributes, useMemo } from 'react';

import { LinkVariant } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Image } from 'src/components/Image/Image';
import arrowIcon from 'src/images/icons/arrow.svg';
import minusIcon from 'src/images/icons/minus.svg';
import plusIcon from 'src/images/icons/plus.svg';
import { Button } from '../Button/Button';
interface BundleSummaryMoreContainerProps extends HTMLAttributes<HTMLElement> {
  showMoreFeatures?: boolean;
  isPlusIconForShowMore?: boolean;
  isWithSpaceLayout?: boolean;
  showMoreCTA?: string;
  showLessCTA?: string;
  toggleMore?: () => void;
}

export const BundleSummaryMoreContainer: FC<BundleSummaryMoreContainerProps> = ({
  showMoreFeatures,
  showMoreCTA,
  showLessCTA,
  toggleMore,
  isWithSpaceLayout,
  className,
  isPlusIconForShowMore,
  ...props
}) => {
  const icon = useMemo(() => {
    if (!isPlusIconForShowMore) return arrowIcon;
    return showMoreFeatures ? minusIcon : plusIcon;
  }, [showMoreFeatures]);

  const [showMoreIconClass, showLessIconClass] = useMemo(() => {
    if (isPlusIconForShowMore) return ['', ''];
    return isWithSpaceLayout ? [styles.arrowIconReversed, ''] : ['', styles.arrowIconReversed];
  }, [isPlusIconForShowMore, isWithSpaceLayout]);

  return (
    <Button
      variant={LinkVariant.TEXT}
      onClick={toggleMore}
      className={cx(styles.cardShowMoreButton, className)}
      {...props}
    >
      {showMoreFeatures ? showLessCTA : showMoreCTA}
      <Image
        src={icon}
        className={cx(styles.icon, {
          [styles.arrowIcon]: !isPlusIconForShowMore,
          [styles.plusIcon]: isPlusIconForShowMore,
          [showMoreIconClass]: !showMoreFeatures,
          [showLessIconClass]: showMoreFeatures,
        })}
        alt=""
      />
    </Button>
  );
};

BundleSummaryMoreContainer.displayName = 'BundleSummaryMoreContainer';
